import React, { useEffect } from "react";
import styles from "../../pages/convert/components/styles/record-audio.module.scss";
import recordingIcon from "@/assets/convert/record.svg";
import stopIcon from "@/assets/convert/stop-record.svg";
import deleteIcon from "@/assets/convert/delete.svg";
import Image from "next/image";
import useRecordAudioData from "@/hooks/ai-tool-process/use-record-audio-data";
import MediaFormatsInputPlayer from "@/components/common/music-player/media-formats-input-player";
import { useRecordAudioTracking } from "@/hooks/mixpanel/media-formats/record-audio-tracker";

const RecordAudioInput = () => {
  const {
    audioURL,
    isRecording,
    startRecording,
    stopRecording,
    resetRecord,
    recordFile,
    setAudioURL,
    recordingTime,
  } = useRecordAudioData();

  const { trackRecordAudio } = useRecordAudioTracking();

  useEffect(() => {
    if (recordFile) {
      const audioURL = URL.createObjectURL(recordFile);
      setAudioURL(audioURL);

      trackRecordAudio(recordingTime);

      return () => {
        URL.revokeObjectURL(audioURL);
      };
    }
  }, [recordFile]);

  return (
    <div className={styles.input_wrapper_default}>
      {audioURL ? (
        <div className={styles.result_wrapper}>
          <div className={styles.bin} onClick={resetRecord}>
            <Image className={styles.bin_icon} src={deleteIcon} alt="delete" />
          </div>
          <MediaFormatsInputPlayer url={audioURL} fileName={"Recorded Audio"} />
        </div>
      ) : (
        <div
          className={styles.input_container}
          onClick={isRecording ? stopRecording : startRecording}
        >
          <Image
            className={styles.record_icon}
            src={isRecording ? stopIcon : recordingIcon}
            alt={isRecording ? "stop" : "record"}
          />
          <div className={styles.main_text}>
            {isRecording ? "Recording..." : "Press to Record"}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecordAudioInput;
